export default "__VITE_ASSET__DVg$t9xr__"